@if (data$ | async; as data) {
  <div class="container">
    <div class="row no-gutters">
      <div class="col-12" [ngClass]="{ 'col-lg-6': data.image?.url }">
        <div class="category-content" [ngClass]="{ 'category-content-half-width': data.image?.url }">
          <aimo-breadcrumb [hideTitle]="true"
            [showBackLink]="false"
            [addFrontPageLink]="false"
            [contentPageTitle]="data.title">
          </aimo-breadcrumb>
          <div class="category-description">
            <h1>{{ data.title }}</h1>
            <div [innerHTML]="data.text|safeHtml">{{ data.text }}</div>
          </div>
        </div>
      </div>
      @if (data.image?.url) {
        <div class="col-12 col-lg-6">
          <div class="category-image">
            <cx-media [loading]="'lazy'" [container]="data.image"></cx-media>
          </div>
        </div>
      }
    </div>
  </div>
}
